import {Stub} from "../feed/components";

const LegalPage = () => {
    return <Stub placeholder={'LegalPage'} />
}

export default LegalPage;
